import { useState } from "react";

const getApiUrl = () => {
  const fullUrl = window.location.href;

  if (fullUrl.includes("dev") || fullUrl.includes("localhost")) {
    return "https://europe-west1-io-physiofit-development.cloudfunctions.net/verifyPracticeUserEmail";
  }

  return "https://europe-west1-io-physiofit-production.cloudfunctions.net/verifyPracticeUserEmail";
};

const getParameterByName = (name: string) => {
  const url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const useHandleVerifyEmail = () => {
  // Verification must never fire on page load: mail scanners prefetch the link,
  // so the request is only sent from the button click (PF-5914).
  const [emailVerificationStatus, setEmailVerificationStatus] = useState<
    "IDLE" | "PENDING" | "SUCCESS" | "INVALID_URL"
  >(() => (getParameterByName("token") ? "IDLE" : "INVALID_URL"));

  const startVerification = async () => {
    const token = getParameterByName("token");
    if (!token) {
      setEmailVerificationStatus("INVALID_URL");
      return;
    }

    setEmailVerificationStatus("PENDING");
    try {
      const response = await fetch(getApiUrl(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token }),
      });

      if (!response.ok) {
        throw new Error(`Fehler: ${response.status}`);
      }

      const data = await response.json();
      setEmailVerificationStatus(data?.status === "success" ? "SUCCESS" : "INVALID_URL");
    } catch (error) {
      console.log("Fehler:", error);
      setEmailVerificationStatus("INVALID_URL");
    }
  };

  return { emailVerificationStatus, startVerification };
};
